import React from "react"
import { AppendIcon, Container, PrependIcon } from "./styles";

interface Props {
    onClick: () => void;
    size?: "small" | "medium" | "large";
    color?: string;
    prependIcon?: string;
    appendIcon?: string;
    disabled?: boolean;
    loading?: boolean;
}

const ButtonDeletePhoto: React.FC<Props> = ({
    onClick,
    children,
    prependIcon,
    appendIcon,
    disabled,
    loading,
    color = "#fff",
    size = "medium" }) => {

    const iconSize = () => {
        switch (size) {
            case "small":
                return 12;
            case "large":
                return 24;
            default:
                return 16;
        }
    }

    return <Container color={color} size={size} disabled={disabled} onClick={(event) => {
        event.stopPropagation();

        if (!disabled) onClick();
    }}>
        {prependIcon !== undefined && <PrependIcon loading={loading} icon={loading ? 'loading' : prependIcon} size={iconSize()} color={color} />}
        {children}
        {appendIcon !== undefined && <AppendIcon loading={loading} icon={loading ? 'loading' : appendIcon} size={iconSize()} color={color} />}
    </Container>
}

export default ButtonDeletePhoto;